module.exports = __webpack_public_path__ + "static/media/breached-pw.9cbb2c82.png";